(function () {
  let cachedProductVariants = null;

  function escapeSelector(value) {
    if (window.CSS?.escape) return CSS.escape(value);
    return value.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  }

  function getProductVariants() {
    if (cachedProductVariants) return cachedProductVariants;

    const script = document.querySelector('[data-product-variants-json]');
    if (!script) return [];

    try {
      cachedProductVariants = JSON.parse(script.textContent);
    } catch {
      cachedProductVariants = [];
    }

    return cachedProductVariants;
  }

  function getVariantSelectData(picker) {
    const variantSelect = picker.closest('.variant-selects');
    if (!variantSelect) return null;

    if (typeof Alpine !== 'undefined' && Alpine.$data) {
      try {
        return Alpine.$data(variantSelect);
      } catch (error) {
        // Fall through to Alpine internal stack.
      }
    }

    return variantSelect._x_dataStack?.[0] || null;
  }

  function findSessionInputs(picker, btn) {
    let dateInput = null;
    let timeInput = null;

    if (btn.dataset.dateInputId) {
      dateInput = picker.querySelector(`#${escapeSelector(btn.dataset.dateInputId)}`);
    }
    if (btn.dataset.timeInputId) {
      timeInput = picker.querySelector(`#${escapeSelector(btn.dataset.timeInputId)}`);
    }

    if (!dateInput && btn.dataset.dateOptionValueId) {
      dateInput = picker.querySelector(
        `input[type="radio"][data-option-value-id="${btn.dataset.dateOptionValueId}"]`
      );
    }
    if (!timeInput && btn.dataset.timeOptionValueId) {
      timeInput = picker.querySelector(
        `input[type="radio"][data-option-value-id="${btn.dataset.timeOptionValueId}"]`
      );
    }

    if (!dateInput && btn.dataset.dateInputName && btn.dataset.dateValue) {
      dateInput = Array.from(picker.querySelectorAll('input[type="radio"]')).find(
        (input) => input.name === btn.dataset.dateInputName && input.value === btn.dataset.dateValue
      );
    }
    if (!timeInput && btn.dataset.timeInputName && btn.dataset.timeValue) {
      timeInput = Array.from(picker.querySelectorAll('input[type="radio"]')).find(
        (input) => input.name === btn.dataset.timeInputName && input.value === btn.dataset.timeValue
      );
    }

    return { dateInput, timeInput };
  }

  function activateSessionButton(btn) {
    const list = btn.closest('[data-workshop-session-list]');
    if (!list) return;

    list.querySelectorAll('[data-workshop-session-btn]').forEach((sessionBtn) => {
      const isActive = sessionBtn === btn;
      sessionBtn.classList.toggle('is-active', isActive);
      sessionBtn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function selectRadioInput(picker, input) {
    if (!input || input.disabled) return false;

    const label = picker.querySelector(`label[for="${input.id}"]`);
    if (label) {
      label.click();
      return input.checked;
    }

    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function countSelectedOptions(picker) {
    return picker.querySelectorAll('fieldset[data-option-index] input[type="radio"]:checked:not(.disabled)').length;
  }

  function countTotalOptions(picker) {
    return picker.querySelectorAll('fieldset[data-option-index]').length;
  }

  function getCurrentSelections(picker) {
    const selections = {};

    picker.querySelectorAll('fieldset[data-option-index]').forEach((fieldset) => {
      const idx = parseInt(fieldset.dataset.optionIndex, 10);
      const checked = fieldset.querySelector('input[type="radio"]:checked:not(.disabled)');
      if (checked) selections[idx] = checked.value;
    });

    return selections;
  }

  function getVariantFromInput(picker, input) {
    const script = picker.querySelector(`script[type="application/json"][data-resource="${input.id}"]`);
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch {
      return null;
    }
  }

  function findVariantForSelections(picker, lampInput, pendingSelections) {
    const selections = pendingSelections || getCurrentSelections(picker);
    const selectedIndices = Object.keys(selections).map((idx) => parseInt(idx, 10));
    const optionCount = countTotalOptions(picker);
    const variants = getProductVariants();

    if (selectedIndices.length === optionCount) {
      const exact = variants.find((variant) =>
        variant.options.every((optionValue, idx) => selections[idx] === optionValue)
      );
      if (exact?.featured_media_id) return exact;
    }

    if (selectedIndices.length > 0) {
      const partial = variants.find((variant) => {
        if (!variant.featured_media_id) return false;
        return selectedIndices.every((idx) => variant.options[idx] === selections[idx]);
      });
      if (partial) return partial;
    }

    if (lampInput) {
      const fallback = getVariantFromInput(picker, lampInput);
      if (fallback?.featured_media?.id) {
        return { featured_media_id: fallback.featured_media.id };
      }
    }

    return null;
  }

  function triggerVariantUpdate(picker, input) {
    if (!input) return;

    const alpineData = getVariantSelectData(picker);
    if (alpineData?.updateVariantSelector) {
      alpineData.updateVariantSelector.call(alpineData, input.id, input.dataset.productUrl || '');
      return;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function goToVariantMedia(picker, variant) {
    const mediaId = variant?.featured_media?.id ?? variant?.featured_media_id;
    if (!mediaId) return;

    const sectionId = picker.id.replace('variant-update-', '');
    const slideVariant = document.getElementsByClassName(`${mediaId}-${sectionId}`);
    const index = parseInt(slideVariant[0]?.getAttribute('index'), 10);
    const splideEl = document.getElementById(`x-product-${sectionId}`);
    const activeEL = document.getElementById(`postion-image-${sectionId}-${mediaId}`);

    const goToSlide = () => {
      if (splideEl?.splide && !Number.isNaN(index)) {
        splideEl.splide.go(index);
      }
    };

    goToSlide();
    if (splideEl && !splideEl.splide) {
      document.addEventListener(`eurus:media-gallery-ready:${sectionId}`, goToSlide, { once: true });
    }

    const stackedEL = document.getElementById(`stacked-${sectionId}`);
    if (stackedEL && activeEL) {
      stackedEL.prepend(activeEL);
    }
  }

  function updateLampMedia(picker, lampInput, pendingSelections) {
    const variant = findVariantForSelections(picker, lampInput, pendingSelections);
    if (variant) goToVariantMedia(picker, variant);
  }

  function handleLampChange(input) {
    const picker = input.closest('.workshop-variant-picker');
    if (!picker) return;

    syncSessionButtons(picker);
    updateLampMedia(picker, input);

    if (countSelectedOptions(picker) >= countTotalOptions(picker)) {
      triggerVariantUpdate(picker, input);
    }
  }

  function syncSessionButtons(picker) {
    const sessionPicker = picker.querySelector('[data-workshop-session-picker]');
    if (!sessionPicker) return;

    const fieldsets = sessionPicker.querySelectorAll('fieldset[data-option-index]');
    const dateChecked = fieldsets[0]?.querySelector('input[type="radio"]:checked');
    const timeChecked = fieldsets[1]?.querySelector('input[type="radio"]:checked');

    sessionPicker.querySelectorAll('[data-workshop-session-btn]').forEach((btn) => {
      const isActive =
        dateChecked &&
        timeChecked &&
        btn.dataset.dateValue === dateChecked.value &&
        btn.dataset.timeValue === timeChecked.value;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function handleSessionClick(btn) {
    const picker = btn.closest('.workshop-variant-picker');
    if (!picker || btn.disabled) return;

    const { dateInput, timeInput } = findSessionInputs(picker, btn);
    if (!dateInput || !timeInput) return;

    activateSessionButton(btn);
    selectRadioInput(picker, dateInput);
    selectRadioInput(picker, timeInput);
    syncSessionButtons(picker);

    if (countSelectedOptions(picker) >= countTotalOptions(picker)) {
      triggerVariantUpdate(picker, timeInput);
    }
  }

  function sortSessionButtons(picker) {
    const sessionPicker = picker.querySelector('[data-workshop-session-picker]');
    const container = sessionPicker?.querySelector('[data-workshop-session-list]');
    if (!container) return;

    const buttons = Array.from(container.querySelectorAll('[data-workshop-session-btn]'));
    buttons.sort((a, b) => {
      const dateA = new Date(a.dataset.sortDate || a.dataset.dateValue);
      const dateB = new Date(b.dataset.sortDate || b.dataset.dateValue);
      if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) return 0;
      return dateA - dateB;
    });
    buttons.forEach((button) => container.appendChild(button));
  }

  function initPicker(picker) {
    if (!picker || picker.dataset.workshopPickerInit === 'true') return;
    picker.dataset.workshopPickerInit = 'true';

    sortSessionButtons(picker);
    syncSessionButtons(picker);

    picker.querySelectorAll('[data-workshop-session-picker] fieldset input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => syncSessionButtons(picker));
    });

    const lampFieldset = picker.querySelector('[data-workshop-lamp-picker]');
    if (lampFieldset) {
      lampFieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.addEventListener('change', () => handleLampChange(input));
      });

      lampFieldset.querySelectorAll('label.workshop-lamp-swatch').forEach((label) => {
        label.addEventListener('mousedown', () => {
          const inputId = label.getAttribute('for');
          const input = inputId ? picker.querySelector(`#${escapeSelector(inputId)}`) : null;
          if (!input || input.disabled) return;

          const lampIndex = parseInt(lampFieldset.dataset.optionIndex, 10);
          const pendingSelections = getCurrentSelections(picker);
          pendingSelections[lampIndex] = input.value;
          updateLampMedia(picker, input, pendingSelections);
        });
      });
    }
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll('.workshop-variant-picker').forEach(initPicker);
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-workshop-session-btn]');
    if (!btn) return;

    event.preventDefault();
    handleSessionClick(btn);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    cachedProductVariants = null;
    initAll(event.target);
  });

  window.xWorkshopVariantPicker = { initAll, syncSessionButtons, triggerVariantUpdate };
})();
